import Typography from '../components/Typography';
import Layout from '../components/Layout';
import BackButton from '../components/BackButton';
import Currency from 'components/Currency/Currency';
import { useNavigate } from '@reach/router';

const AmountMessageSummary = () => {
  return (
    <div className="px-6 border-[#F3F4F6] border-solid rounded-[24px]">
      <div className="flex justify-between py-[18px] border-b border-solid border-t-0 border-l-0 border-r-0 border-b-[#F3F4F6]">
        <Typography
          className="text-[18px] my-auto h-8 leading-[32px]"
          color="secondary"
        >
          Card Amount
        </Typography>
        <Typography
          className="text-[24px] my-auto h-8 leading-[32px]"
          color="green"
          weight="bold"
        >
          <Currency amount={5000} />
        </Typography>
      </div>
      <div className="flex justify-between py-[18px]">
        <Typography
          className="text-[18px] my-auto leading-[32px] h-8"
          color="secondary"
        >
          Message
        </Typography>
        <Typography
          className="text-[24px] flex gap-x-1 my-auto leading-[32px] h-8"
          weight="bold"
        >
          <div className="my-auto">Video</div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            className="my-auto"
          >
            <path
              d="M7.5 13.4766L4.60938 10.5859C4.29688 10.2734 3.75 10.2734 3.4375 10.5859C3.125 10.8984 3.125 11.4453 3.4375 11.7578L6.91406 15.2344C7.22656 15.5859 7.77344 15.5859 8.08594 15.2344L16.9141 6.40625C17.2266 6.09375 17.2266 5.58594 16.9141 5.23438C16.6016 4.92188 16.0547 4.92188 15.7422 5.23438L7.5 13.4766Z"
              fill="#16A34A"
            />
          </svg>
        </Typography>
      </div>
    </div>
  );
};

const RadioButton = () => {
  return (
    <div className="rounded-[24px] border-solid border-[#3E6A3E] flex justify-between bg-[#F0FDF4] p-4">
      <div className="flex gap-x-4">
        <div className="bg-[#E5E7EB] py-2 px-4 rounded-[4px]">
          <Typography className="text-[12px]" weight="bold">
            AP
          </Typography>
        </div>
        <Typography className="text-[18px] my-auto" weight="semibold">
          Cauze Account
        </Typography>
      </div>
      <span className="my-auto">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="1"
            y="1"
            width="22"
            height="22"
            rx="11"
            stroke="#3B82F6"
            stroke-width="2"
          />
          <rect x="6" y="6" width="12" height="12" rx="6" fill="#3B82F6" />
        </svg>
      </span>
    </div>
  );
};

const LoadCardPay = () => {
  const navigate = useNavigate();
  return (
    <Layout className="pt-5 px-6">
      <div className="flex gap-x-4 mb-5">
        <BackButton />
        <Typography weight="bold" className="text-[18px] my-auto">
          CONFIRM & PAY
        </Typography>
      </div>
      <AmountMessageSummary />
      <div className="mb-8" />
      <Typography className="mb-4" color="secondary" weight="semibold">
        Payment Method
      </Typography>
      <div className="flex flex-col gap-y-4 mb-4">
        <RadioButton />
        <RadioButton />
        <RadioButton />
      </div>
      <button className="mb-7 cz-btn-outline black w-full">
        Add Payment Method
      </button>
      <button
        className="cz-btn-brand w-full"
        onClick={() => navigate('/gift-redeem/load/confirmation')}
      >
        Donate $50
      </button>
    </Layout>
  );
};

export default LoadCardPay;
